import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
  pathToBase64,
  isColor
} from '@/utils'

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  const background = await getBackground(data?.customTheme)

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "90_s7HGDJi",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 29.14288713910761,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lbmCnK6SuP",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 28.900997375328085,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "xC7usbcOCU",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 29.041784776902887,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "qg_KAeUNcw",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 29.77742782152231,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "G-Mm2BjiEa",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 29.438530183727035,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "eMSvTw44Ll",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 38.80283464566929,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "oGlh_k371S",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 38.560839895013125,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "OIPDC2ewqY",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 38.70162729658793,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Ugt3yjMdk9",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 39.43737532808399,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "CwbXR3MnaI",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 39.098372703412075,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ljv5gxkpLR",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 48.462782152230965,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Td1Omb8oet",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 48.220787401574796,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2x-OG3lvUA",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 48.36157480314961,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k1qFgBNts6",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 49.09732283464567,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "wTsikN_hTP",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 48.75832020997375,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8QfbnNDCMC",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 58.122624671916014,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SSPMaDHJ27",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 57.88073490813648,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2toJCspTio",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 58.02152230971128,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2-aM32BICa",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 58.75727034120735,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "304l2zcFHH",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 58.41826771653543,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "sLWOD0z9K-",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233604,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: 微软雅黑;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "nMLQeQVOXE",
        width: 187.09910761154856,
        height: 187.09910761154856,
        left: 438.07905511811026,
        top: 95.90645669291338,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "QkboGlz3GA",
        width: 49.89312335958005,
        height: 49.89312335958005,
        left: 506.6820997375328,
        top: 162.13742782152232,
        viewBox: [1024, 1024],
        path: "M985.20746667 343.50079998l-303.32586667-44.08319999L546.28693333 24.5248c-3.70346666-7.5264-9.79626667-13.6192-17.32266665-17.32266668-18.87573334-9.3184-41.81333333-1.55306667-51.25120001 17.32266668L342.1184 299.41759999l-303.32586667 44.08319999c-8.36266667 1.19466667-16.00853333 5.13706667-21.8624 11.11040001-14.69440001 15.17226667-14.45546667 39.30453334 0.71679999 54.1184l219.46026668 213.9648-51.84853333 302.1312c-1.43359999 8.24320001-0.11946667 16.8448 3.82293333 24.25173333 9.79626667 18.6368 32.9728 25.92426667 51.6096 16.00853334L512 822.44266665l271.3088 142.64320001c7.40693333 3.9424 16.00853333 5.25653333 24.25173333 3.82293333 20.78719999-3.584 34.7648-23.296 31.1808-44.0832l-51.84853333-302.1312 219.46026668-213.9648c5.97333334-5.85386666 9.91573333-13.49973334 11.11039999-21.8624 3.2256-20.90666667-11.34933333-40.26026667-32.256-43.36640001z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        special: true,
      },
      {
        type: "shape",
        id: "d6sY3xUjCT",
        width: 156.80682414698163,
        height: 156.80682414698163,
        left: 374.82183727034123,
        top: 212.03044619422573,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "bE7-fk0tok",
        width: 124.7327034120735,
        height: 124.7327034120735,
        left: 484.40839895013124,
        top: 311.029501312336,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}c7`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "piBt6sY1Rg",
        width: 109.58656167979004,
        height: 109.58656167979004,
        left: 428.72419947506563,
        top: 391.0320209973753,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}99`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "pubgiY6Hw2",
        width: 331.76766404199475,
        height: 50,
        left: 659.1000524934383,
        top: 107.16482939632546,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 16.65625px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[0].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "t1Dy1-yTsf",
        width: 270.87758530183726,
        height: 80,
        left: 659.1000524934383,
        top: 150.36708745770187,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 12.5px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "pZlTxmoFst",
        width: 324.2016797900263,
        height: 50,
        left: 659.1000524934383,
        top: 288.9182152230971,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 16.65625px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[2].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "t0Sk9tRKzA",
        width: 270.87758530183726,
        height: 80,
        left: 659.1000524934383,
        top: 336.0320209973753,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 12.5px;font-family: Microsoft Yahei;">${node.children[2].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "n84l9bDMg0",
        width: 302.98404199475067,
        height: 50,
        left: 79.60451443569553,
        top: 368.8372703412074,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><span style="font-size: 16.65625px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[3].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "ImN0nZe9Ni",
        width: 270.87758530183726,
        height: 80,
        left: 111.71097112860893,
        top: 410.42813648293964,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><span style="font-size: 12.5px;font-family: Microsoft Yahei;">${node.children[3].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "ZPAJFOJHwK",
        width: 306.90813648293965,
        height: 50,
        left: 37.31653543307087,
        top: 175.3670874577019,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><span style="font-size: 16.65625px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[1].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "AgykhG2Fma",
        width: 282.6153280839895,
        height: 80,
        left: 62.650078740157475,
        top: 226.25,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><span style="font-size: 12.5px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "9nATrkB8me",
        width: 193.55653543307085,
        height: 193.55653543307085,
        left: 823.6959580052493,
        top: -135.43391076115486,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "EqUsMI5Lp2",
        width: 120.69679790026247,
        height: 120.69679790026247,
        left: 750.6435695538057,
        top: 500.6185826771653,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "KtGkqKf2ry",
        width: 173.64377952755905,
        height: 173.64377952755905,
        left: -102.36703412073491,
        top: 339.4005249343832,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "cC-9M0FS9s",
        width: 40.63790026246719,
        height: 40.63790026246719,
        left: 753.9008923884514,
        top: 45.704671916010504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "OanEUJA1Yd",
        width: 49.89312335958005,
        height: 49.89312335958005,
        left: 459.4618372703412,
        top: 420.8787401574803,
        viewBox: [1024, 1024],
        path: "M491.70164031 97.48884502a25.89076502 25.89076502 0 0 1 40.59671938 0L745.66415762 367.01171317a25.89076502 25.89076502 0 0 0 30.49932208 7.72839349l208.00640948-89.14190458a25.89076502 25.89076502 0 0 1 35.56096592 29.06238339l-115.18801541 554.96855704A103.56306132 103.56306132 0 0 1 803.14165689 952.14301275H220.85834311a103.56306132 103.56306132 0 0 1-101.4011828-82.51387024l-115.18801541-554.96855704a25.89076502 25.89076502 0 0 1 35.54802012-29.06238339l208.01935528 89.14190458a25.89076502 25.89076502 0 0 0 30.49932208-7.72839349l213.36579793-269.52286815z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        special: true,
      },
      {
        type: "shape",
        id: "5VlnTFsBcy",
        width: 49.89312335958005,
        height: 49.89312335958005,
        left: 521.828188976378,
        top: 343.89070866141736,
        viewBox: [1024, 1024],
        path: "M910.60451556 640.96028445c-20.38897778-65.49959112-43.83630221-120.54983112-79.89930667-210.64362666C836.31217778 193.67708444 737.93535999 2.27555556 511.36284444 2.27555556 282.24170667 2.27555556 186.03121778 197.50001778 192.14791111 430.31665779c-36.19043555 90.22122667-59.51032888 144.88917333-79.89930667 210.64362666-43.32657778 139.53706668-29.30915556 197.26336001-18.60494222 198.53767111 22.9376 2.80348444 89.32920888-105.00323556 89.32920889-105.00323556 0 62.44124445 32.11264001 143.86972444 101.69002667 202.61546667-33.64181333 10.32192-109.20846222 38.10190221-91.24067556 68.55793777 14.52714667 24.59420444 250.01984 15.67402668 317.94062222 8.02816 67.92078222 7.64586667 303.41347556 16.56604444 317.94062223-8.02816 17.96778667-30.32860444-57.72629333-58.23601779-91.24067555-68.55793777 69.57738667-58.87317334 101.69002667-140.30165333 101.69002667-202.61546667 0 0 66.39160889 107.80672 89.32920888 105.00323556 10.83164445-1.40174222 24.84906667-59.12803556-18.47751111-198.53767111z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        special: true,
      },
      {
        type: "shape",
        id: "aPzpAeHvSw",
        width: 49.89312335958005,
        height: 49.89312335958005,
        left: 428.278687664042,
        top: 265.48729658792655,
        viewBox: [1024, 1024],
        path: "M512 512c140.82958222 0 254.86222222-114.03264 254.86222222-254.86222222S652.82958222 2.27555555 512 2.27555555a254.78940445 254.78940445 0 0 0-254.86222222 254.86222223C257.13777778 397.96736 371.17041778 512 512 512z m0 72.81777778c-170.10232889 0-509.72444445 97.57582222-509.72444445 291.27111111v145.63555556h1019.4488889v-145.63555556c0-193.69528889-339.62211555-291.27111111-509.72444445-291.27111111z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        special: true,
      },
    ],
    background
  };
};

export default nodule;
